import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Moment from 'react-moment';
import {userGroupUrlCheck,getUserTimeZone} from '../../../utils/userGroupUrlCheck';
import {URL_IMG} from '../../../configs/urlConfigs';
import {ROUTE_REFRESH, ROUTE_AFFILIATE_REFRESH, PAGENUMROWS_AFFILIATE,PAGING_END_INDEX,LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP,RANDOM_COLORS,ROUTE_AFFILIATE_CLIENT_PROFILE,ROUTE_AFFILIATE_CREW_PROFILE,TAB6,TAB4} from '../../../configs/staticConfigs';
import{ MSG_NOT_FOUND, MSG_SERVER_DATA_FETCH_ERROR} from '../../../configs/msgConfigs';
import { LBL_APP_NAME, LBL_SLNUM, LBL_NAME, LBL_CERTIFICATE, LBL_CERTIFICATES, LBL_START_DATE,  LBL_END_DATE, LBL_DAYS_PENDING,LBL_DAYS_EXCEEDED, LBL_SKILL, LBL_VERIFIED, LBL_CLIENT, LBL_CREW , LBL_EXPIRING_CERTIFICATES, LBL_EXPIRED_CERTIFICATES, LBL_SEARCH_CERTIFICATES, LBL_SETTINGS } from '../../../configs/labelConfigs'; // LBL_CLEAR_FILTERS

import { clientProfileActiveTabAction } from '../../../actions/clientActions';
import { crewProfileActiveTabAction } from '../../../actions/crewActions';
import { certificatesListAction, expiringCertificateTitleAction } from '../../../actions/settings/affiliates/certificateActions';
import * as types from '../../../actions';


import { converDateToLocal,convertDecimalToHHMM } from '../../../utils/commonUtilities';

import ModalWindow from '../../commons/helpers/modalWindow';
import Paginator from '../../commons/helpers/paginator';
import Toast from '../../commons/helpers/toast';
import Filter from '../../commons/helpers/filterBy';
import FilterCertificates from './filterCertificatesComponent';
import {fromExpiryCertificates} from '../../../actions/commonActions'; 

class Certificates extends Component {

   constructor(props){
      super(props)

      this.state = {
         activePage:1,
         startIndex : 0, 
         endIndex : PAGING_END_INDEX,
         perPageCount:PAGENUMROWS_AFFILIATE,
         sortField:'crew_skill__affiliate_skill__skill_name', 
         duration: 30,
         sortOrder:'',  
         toastMessage:'',
         toastFlag:false,
         toastSuccess:true, 
         selectedFeedback:'',  
         formErrors_noRows : '',   
         formErrors:{           
            rating:''
         },          
         certificatesList:[],
         selectedFeedbackId:0,
         rand :Math.floor(Math.random()*RANDOM_COLORS.length),
         isClientPage:false,
         filterClicked: 0,
         resetFilterClicked: 0,
         applyFilterClicked: 0,
         applyFilter: 0,
         filtersData: {},
         isFilterOn: false,
         searchText:'',
         activeRowId: 0,
         expiredCertificates:false
      } 
      this.modal = React.createRef();
   }    

   showClientCrewProfile = (e,profileType,profileId) => {
      if(profileType==='client') {
         this.props.clientProfileActiveTabAction(TAB6); 
         this.props.history.push(ROUTE_AFFILIATE_CLIENT_PROFILE+'/'+profileId);
         this.props.fromExpiryCertificates(true);
      }
      else if(profileType==='crew') {
         this.props.crewProfileActiveTabAction(TAB4); 
         this.props.history.push(ROUTE_AFFILIATE_CREW_PROFILE+'/'+profileId);
         this.props.fromExpiryCertificates(true);
      }
   } 
   
   onResetFiltersButton = () => {   
      let resetFilterClicked = this.state.resetFilterClicked+1; 
      if(this.state.applyFilter > 0) {
          this.setState({resetFilterClicked,applyFilter:0,activePage:1, sortOrder:'', sortField:'-created_on', searchQuote:''}, () => {
            // this.props.feedbackListAction({pageSize:this.state.perPageCount,page:1,sortBy:this.state.sortOrder+this.state.sortField,search:this.state.searchText});
              
              if(this.state.isFilterOn) {
                  document.getElementById("filterIcon").classList.add('active');   
              }
              else if(!this.state.isFilterOn) {
                  document.getElementById("filterIcon").classList.remove('active');   
              }
          });
      }
      else {
          this.setState({resetFilterClicked,applyFilter:0}); 
      }
   }

   onShowFilterBy = () => {
      let filterClicked = (this.state.filterClicked+1);
      this.setState(prevState => ({ isFilterOn: !prevState.isFilterOn, filterClicked:filterClicked }));
      document.getElementById("filterByMenu").classList.toggle('active');      
      document.getElementById("filterIcon").classList.toggle('active');   
      // let filterByMenu = document.getElementById('filterByMenu');    
      // let filterTab = document.getElementById('filterTab');
      // filterTab.style.display = 'block';        
      // if(this.state.isFilterOn){
      //     filterByMenu.style.width='450px';
      //     filterByMenu.style.right='-450px';
      // }else{
      //     filterByMenu.style.width='450px';
      //     filterByMenu.style.right='0';
      // }
   }

   onSearch = (e)=>{
      this.setState({searchText:e.target.value}, () => {
         if(this.state.searchText.length >=3 || this.state.searchText.length===0) { 
            this.props.certificatesListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:this.state.searchText,duration:this.state.duration,expiredCertificates:this.state.expiredCertificates});
         }
      })
   }

   onHandleChange = (e) =>{
      const {name,value}  = e.target;   
      let {feedbackData} = this.state;  
      feedbackData[name]   = value;    
      this.setState({feedbackData});
   }  

   
   onPagePrevious = (e) =>{
      const {
          startIndex, endIndex        
      } = this.state
      let previousPage = startIndex+1-PAGING_END_INDEX
      // this.props.feedbackListAction({pageSize:this.state.perPageCount,page:previousPage,sortBy:this.state.sortOrder+this.state.sortField,search:this.state.selectedFeedback});
      if(startIndex===0){
          this.setState({
              activePage: previousPage,
              startIndex : startIndex,
              endIndex : endIndex
          });  
      }else{
          this.setState({
              activePage: previousPage,
              startIndex : startIndex - PAGING_END_INDEX,
              endIndex : endIndex - PAGING_END_INDEX
          });  
      }                           
   }

   onPageUp = (e) => {       

      // this.props.feedbackListAction({pageSize:this.state.perPageCount,page:e.target.id,sortBy:this.state.sortOrder+this.state.sortField,search:this.state.selectedFeedback});
 
      this.setState({
          activePage: Number(e.target.id)                   
      });
   }

   onPageNext = (e) =>{   
      const {
          activePage,startIndex,endIndex            
      } = this.state     
      const {
          totalPage            
      } = this.props
             
      let nextPage = startIndex+1+PAGING_END_INDEX;
      // this.props.feedbackListAction({pageSize:this.state.perPageCount,page:nextPage,sortBy:this.state.sortOrder+this.state.sortField,search:this.state.selectedFeedback});
      if(endIndex===totalPage || totalPage<=PAGING_END_INDEX){
          this.setState({
              activePage: nextPage,
              startIndex : startIndex,
              endIndex : endIndex
          }); 
      }else{
          this.setState({
              activePage: nextPage,
              startIndex : startIndex + PAGING_END_INDEX,
              endIndex : endIndex + PAGING_END_INDEX
          });  
      }                                   
   }

   onSort = (event,sortKey) =>{        
      let sOrder = '';
      // if(this.state.sortField===sortKey){         
      //     sOrder = (this.state.sortOrder==='-') ? '' : '-';
      //     this.props.feedbackListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:this.state.selectedFeedback});
      //     this.setState({ sortOrder:sOrder });            
      // }else{
      //     this.setState({ sortField:sortKey });
      //     this.props.feedbackListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:this.state.selectedFeedback});
      // }        
   }

   onModalFormReset = () =>{       
      this.setState({
         feedbackId:'',
         formErrors:{
            rating:'',          
         }
      }); 
   }

   onCloseToast = () =>{
      this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
   } 

   setToasterState(isEnabled,message,isSucces,ms=3000){
      this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
      setTimeout(()=> {
          this.onCloseToast();
      }, ms);
   }

   onShowActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.toggle('show');
      dropdownMenu.classList.toggle('show');      

      if(this.state.activeRowId===0){   
         this.setState({activeRowId:rowId}); 
         document.getElementById('img-action-'+rowId).focus();
      }else if(this.state.activeRowId===rowId){ 
         this.setState({activeRowId:0}); 
      }else if(this.state.activeRowId!==rowId){   
         dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
         dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
         dropdown.classList.toggle('show');
         dropdownMenu.classList.toggle('show');
         this.setState({activeRowId:rowId}); 
         document.getElementById('img-action-'+rowId).focus();
      }        
      
   }    

   onHideActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.remove('show');
      dropdownMenu.classList.remove('show');
      this.setState({activeRowId:0});
   }

   editCertificate = (event, rowId) =>{ 

   }

   deleteBtnClick = (rowId,name) =>{
      // this.setState({
      //    activeUserId:rowId,
      //    activeUserName:name          
      // }); 
      // this.modalDelete.current.handleOpenModal();
      // this.modal.current.handleModelCloseOnly();     
   }

   onDeleteAction = () =>{
      // let activeUserId = this.state.activeUserId;
      // this.props.associateUserDeleteAction(activeUserId);
      // this.modalDelete.current.handleModelClose();  
      // this.modal.current.handleModelClose();                          
   } 

   deletePopup = () => {
      // let fullName = this.state.activeUserData.first_name+' '+this.state.activeUserData.last_name; 
      // this.deleteBtnClick(this.state.activeUserId,fullName); 
   }

  onChangeRadio = (e) =>{
    let { expiredCertificates } = this.state;
    let {name,value,id}  = e.target;
    if(id==="radio2"){
      expiredCertificates = true;
      this.props.expiringCertificateTitleAction('expired');
    }else{
      expiredCertificates = false;
      this.props.expiringCertificateTitleAction('expiring');
    }
    this.setState({expiredCertificates:expiredCertificates});  
    this.props.certificatesListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:this.state.searchText,duration:this.state.duration,expiredCertificates:expiredCertificates});

  }
   
   componentDidUpdate(prevProps) {
      const {isFilterOn,numRows,totalPage,status,activity,errorData,certificateDetails} = this.props;   
      if (isFilterOn !== prevProps.isFilterOn) {
         this.inputFilter.click();   
      } 
      if (activity && activity !== prevProps.activity) {
         let arrResp = activity.split('~~'); 
         let actString = arrResp[0]; 

         if(actString===types.CERTIFICATES_LIST_SUCCESS){  
            let errMsg = ''; 
            if(status===200) {
               if(Array.isArray(certificateDetails) && certificateDetails.length===0) errMsg = MSG_NOT_FOUND;
               this.setState({certificatesList:certificateDetails, formErrors_noRows:errMsg}); 
            }
         }else if(actString===types.CERTIFICATES_LIST_ERROR){
            console.log(JSON.stringify(errorData)); 
            this.setToasterState(true,MSG_SERVER_DATA_FETCH_ERROR,false);
         }
      }
   }

   componentDidMount() {
        const { location } = this.props;
      
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }   
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
            this.setState({isClientPage:false});  
        }else if(userGroup===LOGIN_CLIENT_GROUP){
            document.body.classList.add('body-client'); 
            this.setState({isClientPage:true});  
        }
        document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+" - "+LBL_CERTIFICATES;     
        this.props.certificatesListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:this.state.searchText,duration:this.state.duration,expiredCertificates:this.state.expiredCertificates});
   }   
  
   render(){

      let {
         activePage,startIndex,endIndex,toastMessage,toastFlag,toastSuccess,certificatesList,formErrors,rand,isClientPage           
     } = this.state  

      const {totalPage,status } = this.props; 

      let userGroupData = userGroupUrlCheck(this.props.location);
      let userGroup = ''; 
      if(userGroupData!==undefined){
         userGroup = userGroupData.user_group; 
      }

      if(status===401 || status===403){
         if(userGroup===LOGIN_AFFILIATE_GROUP){
            return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
         }else{
            return <Redirect to={ROUTE_REFRESH} />;
         }
      }     
     
      let timeZone =  getUserTimeZone(this.props.location);
      
      // FOR TESTING PURPOSE - PLEASE DELETE AFTER TESTING 
      // if(certificatesList.length===0) {
      //    certificatesList = [{"id": 2, "crew_id": 13, "crew_name": "v4 v4", "skill_id": 65, "skill_name": "Cherry-picker", "valid_from": "2020-08-10", "valid_to": "2020-08-15", "days": -6, "status": 1, "status_value": "Not Verified", "document_id": "67", "document_name": "Address proof"}];
      // }

      return(
         <React.Fragment>
            <div className="col-md-12">
               <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
               <div className="box">

                  <div className="box-head">
                     <div className="dataTables_filter"><label>
                        <input type="search" className="" placeholder={LBL_SEARCH_CERTIFICATES} id="my-search-input" onChange={this.onSearch} /></label>
                     </div>    
                     {/* <div  className={this.state.applyFilter ? 'filter-btn-wrapper  text-primary-filter':'filter-btn-wrapper text-primary'}>
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 450, hide: 250 }}
                            overlay={<Tooltip id="filterIcon-tooltip" style={{
                                opacity: 0.4,
                              }}>
                            Filter
                          </Tooltip>}
                        >
                            <button id="filterIcon" ref={input => this.inputFilter = input} onClick={this.onShowFilterBy} className={this.state.applyFilter ? 'filter-btn  text-primary-filter':'filter-btn text-primary'}><i className="las la-filter"></i></button>
                        </OverlayTrigger>
                     </div>
                     {this.state.applyFilter > 0 && 
                        <div className="text-12 div150" onClick={this.onResetFiltersButton} >&nbsp; &nbsp; <Link to="#" >{LBL_CLEAR_FILTERS}</Link></div>}  */}

                      <div className="float-right">
                          <div className="checkbox-wrapper">
                              <div className="custom-radio">
                                  <input type="radio" id="radio1" name="radio" defaultChecked="checked" onChange={this.onChangeRadio} />
                                  <label className="radio" htmlFor="radio1"></label>
                                  <label className="labeltext" htmlFor="radio1">{LBL_EXPIRING_CERTIFICATES}</label>
                              </div>
                              <div className="custom-radio">
                                  <input type="radio" id="radio2" name="radio" onChange={this.onChangeRadio} />
                                  <label className="radio" htmlFor="radio2"></label>
                                  <label className="labeltext" htmlFor="radio2">{LBL_EXPIRED_CERTIFICATES}</label>
                              </div>
                          </div>
                    </div>
                  </div>
                  


                  <div className="box-content">
                     <div className="table-responsive feedback">
                        <table id="data-table" className="table" style={{width:"100%"}}>
                           <thead>
                           {/* onClick={(e) => this.onSort(e,'')}className="shift-date sorting_asc" 
                           onClick={(e) => this.onSort(e,'')} className="sorting_asc shift-crew" */}
                              <tr>
                                 <th>{LBL_SLNUM}</th>                                
                                 <th>{LBL_CLIENT+'/'+LBL_CREW+' '+LBL_NAME}</th>
                                 <th>{LBL_CLIENT+'/'+LBL_CREW}</th>
                                 <th>{LBL_SKILL}</th>
                                 <th>{LBL_CERTIFICATE}</th>
                                 <th>{LBL_VERIFIED}</th>
                                 <th>{LBL_START_DATE}</th>
                                 <th>{LBL_END_DATE}</th>
                                 <th className="text-center">{this.state.expiredCertificates ? LBL_DAYS_EXCEEDED : LBL_DAYS_PENDING} </th>   
                                 <th></th>
                              </tr>
                           </thead>
                           <tbody>
                           
                           {(this.state.formErrors_noRows.length > 1)  && 
                              <tr>
                                 <td colSpan="10" className="text-center">{this.state.formErrors_noRows}</td>
                              </tr>
                           }
                           { certificatesList.length > 0 && certificatesList.map((item, index)  => {
                              let indeNum = (PAGENUMROWS_AFFILIATE*(activePage-1))+index+1; 
                              // client_id: null client_name: null crew_id: 281 crew_name: "Melman Parker" days: -10 document_id: "840" document_name: "ABULANCE DRIVER Driving License" id: 72 skill_id: null skill_name: null status: 2 status_value: "Verified" valid_from: "2020-03-03" valid_to: "2020-08-18"
                              let validFrom = converDateToLocal(item.valid_from,"00:00",'ddmmyyyy'); 
                              let validTo = converDateToLocal(item.valid_to,"00:00",'ddmmyyyy');  
                                    return (
                                       <React.Fragment key={index}>
                                          <tr>
                                             <td>{indeNum}</td>
                                             <td>
                                             {/* {item.client_id && <Link onClick={(e) => this.showClientCrewProfile(e,'client',item.client_id)} to="#" >{item.client_name}</Link>} */}
                                             {item.client_id && <Link to={ROUTE_AFFILIATE_CLIENT_PROFILE+'/'+item.client_id}>{item.client_name}</Link>}
                                             {item.crew_id && <Link onClick={(e) => this.showClientCrewProfile(e, 'crew',item.crew_id)} to="#" >{item.crew_name}</Link>}
                                             </td>
                                             <td>{item.client_id ? LBL_CLIENT : item.crew_id ? LBL_CREW : '' }</td>
                                             <td>{item.skill_name}</td>
                                             <td>{item.document_name}</td>
                                             <td>{item.status_value}</td>
                                             <td>{validFrom}</td>
                                             <td>{validTo}</td>  
                                             <td className={Number(item.days) <= 0?"text-center text-red ":'text-center'}>
                                                {/* <Moment fromNow>{new Date(item.valid_to)}</Moment> */}
                                                {item.days}
                                             </td> 
                                             {/* <td>
                                                <div className="dropdown" id={'dropdown-'+item.id}>
                                                   <button className="dropdown-toggle" type="button"
                                                      id={'dropdownMenuButton-'+item.id} data-toggle="dropdown"
                                                      aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)}
                                                      >
                                                      <input type="image" id={"img-action-"+item.id} src={require('../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                   </button>
                                                   <div className="dropdown-menu" id={'dropdown-menu-'+item.id}
                                                      aria-labelledby={'dropdownMenuButton-'+item.id}>
                                                         <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editCertificate(e,item.id)}>Edit</Link>
                                                         <Link className="dropdown-item delete"
                                                         to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.company_name)}>Delete</Link>
                                                   </div>
                                                </div>
                                             </td> */}
                                             <th></th>
                                        </tr>    
                                       </React.Fragment>                                        
                                     )
                                  })      
                                } 
                                                   
                           </tbody>
                        </table>
                        <Paginator totalPage={totalPage} activePage={activePage} startIndex={startIndex} endIndex={endIndex} onPagePrevious={this.onPagePrevious} onPageUp={this.onPageUp} onPageNext={this.onPageNext}/>
                        <div className="clear-b-scroll-sector">&nbsp;</div>   
                        <div>&nbsp;</div>   
                        <div>&nbsp;</div>   
                        <div>&nbsp;</div>   
                        
                     </div>
                  </div>                    
               </div>              

               <ModalWindow ref={this.modal} header="" saveFormData={ (e)=>this.onSaveFormData()} resetModalForm={this.onModalFormReset} type="save">                  
                  <div className="row mb-3">
                     <div className="col-md-12">
                           <div className="row">
                              <div className="col-md-2"><label>&nbsp;</label></div>
                              <div className="col-md-10">
                                 <span className="review-text"></span>                              
                              </div>
                           </div>
                     </div>                     
                  </div>    
               </ModalWindow>
            </div>

            <Filter onResetFiltersButton={this.onResetFiltersButton} onApplyFilterButton={this.onApplyFilterButton}>
               <FilterCertificates filterClicked={this.state.filterClicked} resetFilterClicked={this.state.resetFilterClicked} applyFilterClicked={this.state.applyFilterClicked} applyFilters={this.applyFilters} isEvent={this.state.isEvent} isClientPage={this.state.isClientPage} clientId={this.state.clientId} />
            </Filter>

         </React.Fragment>
        )
    }

}
const mapStateToProps = (state) => {
      return {
        certificateDetails:state.certificates.certificateDetails,           
        status:state.certificates.status,
        activity:state.certificates.activity,
        errorData:state.certificates.errorData,

      //   totalPage:state.certificates.certificatesTotalPage,
      //   numRows:state.certificates.certificatesNumRows,
      //   count:state.certificates.certificatesCount,
      //   isFilterOn: certificates.commons.isFilterOn,
      }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
      certificatesListAction:certificatesListAction,
      clientProfileActiveTabAction:clientProfileActiveTabAction,
      crewProfileActiveTabAction:crewProfileActiveTabAction,
      expiringCertificateTitleAction:expiringCertificateTitleAction,
      fromExpiryCertificates:fromExpiryCertificates
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(Certificates);